(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestMedication', {
        templateUrl: '/core-ui/component-views/ap-erx-request-medication.html',
        bindings: {
            label: '<',
            requestedMed: '<',
            currentPrescription: '<?',
        },
        controllerAs: 'vm',
        controller: [
            ApErxRequestMedication,
        ],
    });

    function ApErxRequestMedication(
    ) {
        var vm = this;
        var rxNormQualifer = {
            BPK: 'RxNorm Branded Package',
            GPK: 'RxNorm Branded Package',
            SCD: 'RxNorm Branded Package',
            SBD: 'RxNorm Semantic Clinical Drug',
        };
        vm.isOpen = false;
        vm.medDescriptionText = medDescriptionText;
        vm.refills = refills;
        vm.substitutionText = substitutionText;
        vm.strengthText = strengthText;
        vm.productCodeText = productCodeText;
        vm.drugDbCodeText = drugDbCodeText;
        vm.drugFormText = drugFormText;
        vm.hasDetails = hasDetails;

        function medDescriptionText(description, ndcDescription) {
            var text = description;
            if(ndcDescription) {
                text += ' (NDC Description: ' + ndcDescription  + ')';
            }
            return text;
        }

        function refills(prescription) {
            var firstInstruction = prescription && prescription.Instructions && prescription.Instructions[0];
            if (!firstInstruction || prescription.Instructions.length > 1) {
                return null;
            }

            var refills = firstInstruction.Refills || 0;

            return refills;
        }

        function substitutionText(prescription) {
            if(!prescription) {
                return null;
            }

            var text = prescription.DispenseAsWritten ?
                'DAW (Substitution Not Allowed)' :
                'Substitution Allowed';
            return text;
        }

        function strengthText(prescription) {
            if(!prescription) {
                return null;
            }

            var text = prescription.DrugStrength;
            if(prescription.DrugStrengthUnits) {
                text += ' ' + prescription.DrugStrengthUnits;
            }
            return text;
        }

        function productCodeText(prescription) {
            if(!prescription) {
                return null;
            }

            var text = prescription.DrugNdc + ' (NDC)';
            return text;
        }

        function drugDbCodeText(prescription) {
            if(!prescription) {
                return null;
            }

            var text = prescription.DrugRxNormCode;
            var qualifier = rxNormQualifer[prescription.DrugRxNormQualifier];
            if(qualifier) {
                text += ' (' + qualifier + ')';
            }
            return text;
        }

        function drugFormText(prescription) {
            if(!prescription) {
                return null;
            }

            var text = prescription.UnitOfMeasureName;
            if(prescription.UnitOfMeasureCode) {
                text += ' (' + prescription.UnitOfMeasureCode  + ')';
            }
            return text;
        }

        function hasDetails() {
            return vm.requestedMed &&
                (vm.requestedMed.WrittenDate ||
                vm.requestedMed.LastFillDate ||
                vm.requestedMed.ExpirationDate ||
                vm.requestedMed.EffectiveDate ||
                vm.requestedMed.PeriodEnd ||
                vm.requestedMed.DateValidated ||
                vm.requestedMed.SoldDate ||
                vm.requestedMed.PriorAuthorizationDescription ||
                vm.requestedMed.PriorAuthorizationStatusTerm);
        }
    }

})(window.angular);
